import mock from './mockAdapter';

// Mock data for order types
const mockOrderTypes = [
  {
    id: 5,
    name: "Obra Pública",
    subtypeName: "Pedido de Precios",
    description: "Trabajos ejecutados mediante pedido de precios",
    prefix: "OP",
    subtypePrefix: "PP",
    code: "PP01",
    documents: null
  },
  {
    id: 4,
    name: "Obra Pública",
    subtypeName: "Contratación Directa",
    description: "Trabajos ejecutados mediante contratación directa",
    prefix: "OP",
    subtypePrefix: "CD",
    code: "CD01",
    documents: null
  },
  {
    id: 3,
    name: "Obra Pública",
    subtypeName: "Licitación Privada",
    description: "Trabajos ejecutados mediante proceso de licitación privada",
    prefix: "OP",
    subtypePrefix: "LPR",
    code: "LPR01",
    documents: null
  },
  {
    id: 2,
    name: "Obra Pública",
    subtypeName: "Licitación Pública",
    description: "Trabajos ejecutados mediante proceso de licitación pública",
    prefix: "OP",
    subtypePrefix: "LPU",
    code: "LPU01",
    documents: null
  },
  {
    id: 1,
    name: "Mantenimiento General",
    subtypeName: "Mantenimiento General",
    description: "Trabajos de mantenimiento rutinario y preventivo",
    prefix: "MG",
    subtypePrefix: "MG",
    code: "MG01",
    documents: null
  }
];

// GET /work-order/order-types - Obtener tipos de orden
mock.onGet('/work-order/order-types').reply(() => {
  return [200, mockOrderTypes];
});
